import { useEffect, useRef } from 'react';

/**
 * Runs `callback` every `interval` ms for the lifetime of the component.
 *
 * Ticks do not touch component state, so the host does not re-render on every tick.
 * The previous reducer-based version bumped a counter on each tick, which re-rendered the
 * host (and, from App, the whole tree) every interval. Callbacks that need a re-render
 * already set their own state.
 */
export default function useTimer(
  interval: number,
  callback: () => void,
  fireImmediately = false,
  name?: string,
) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    let count = 0;
    const tick = () => {
      if (name) console.debug('Triggering timer', name, count);
      count += 1;
      callbackRef.current();
    };

    if (fireImmediately) tick();

    const timer = setInterval(tick, interval);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
